import React from "react";
import bubba from "../../../assets/images/404.jpg";
import Button from "../../Button";

import "./PageNotFound.css";
import { useQuery } from "@apollo/client";
import { GET_WHO_AM_I } from "../Account/queries";

export default function PageNotFound({ errorCode }) {
  const { loading, error, data } = useQuery(GET_WHO_AM_I);

  let subHeader;
  let byline;
  let returnLink;

  if (errorCode === 404) {
    subHeader = "Looks like you landed out of bounds.";
    byline = "Happens to the best of us.";
    returnLink = "/";
  } else {
    subHeader = "Oops, something went wrong.";
    byline = (
      <>
        If this keeps happening, contact{" "}
        <a href="mailto: support@gupscorner.com">support@gupscorner.com</a>.
      </>
    );

    if (!loading && !data.whoAmI) {
      returnLink = "/logout";
    } else {
      returnLink = "/";
    }
  }

  return (
    <div className="page-not-found-container">
      <h1 className="page-not-found-header">{errorCode}</h1>

      <img
        className="page-not-found-image"
        src={bubba}
        alt="Bubba Watson pointing fore left"
      />

      <h3 className="page-not-found-subheader">{subHeader}</h3>
      <p className="page-not-found-byline">{byline}</p>

      <Button href={returnLink}>Home</Button>
    </div>
  );
}
